import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import * as Icons from "react-bootstrap-icons";

export default function MPaper({ label, content, className, defaultExpanded }) {
  return (
    <Accordion defaultExpanded={defaultExpanded} className={`${className ? className : ''} m-Paper`}>
      <AccordionSummary
        expandIcon={<Icons.ChevronDown />}
        className="m-paper-label"
      >
        <span>
          <i>{label}</i>
        </span>
      </AccordionSummary>
      <AccordionDetails className="m-paper-content">{content}</AccordionDetails>
    </Accordion>
  );
}
